import { render } from "./ServicesPart.vue?vue&type=template&id=ab23c248&scoped=true"
import script from "./ServicesPart.vue?vue&type=script&lang=js"
export * from "./ServicesPart.vue?vue&type=script&lang=js"

import "./ServicesPart.vue?vue&type=style&index=0&id=ab23c248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab23c248"]])

export default __exports__